import {render as reactRender, hydrate as reactHydrate} from 'react-dom';
import AppStateComponent from '../components/AppStateComponent';
import appFactory from '../appFactory';

const STRING = 'string';

export default function renderDom (App, _opts) {
    const {
        hydrate = false,
        initState
    } = _opts;

    let {mount} = _opts;

    if (typeof mount === STRING) {
        mount = document.querySelector(mount);
    }

    const opts = {
        ..._opts,
        // Don't render the state on the client
        // unless we're hydrating
        renderState: false
    };
    // If mount is available, and we're hydrating the app
    // rebuild the initState from a hydratable state
    if (mount && hydrate) {
        opts.initState = AppStateComponent.hydrateState(mount, initState);
    }

    let renderAction = reactRender;

    if (hydrate) {
        renderAction = reactHydrate;
    }

    const appRoot = appFactory(App, opts);

    return {
        app: appRoot.app,
        store: appRoot.store,
        render: () => {
            return renderAction(
                appRoot.app,
                mount
            );
        },
        prefetch: appRoot.prefetch
    };
}
